import { render } from "./ModalWithdrawal.vue?vue&type=template&id=4e66b9c6&scoped=true"
import script from "./ModalWithdrawal.vue?vue&type=script&lang=js"
export * from "./ModalWithdrawal.vue?vue&type=script&lang=js"

import "./ModalWithdrawal.vue?vue&type=style&index=0&id=4e66b9c6&scoped=true&lang=css"

import exportComponent from "/Users/afolabitope/Documents/apps/redge/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e66b9c6"]])

export default __exports__